import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InnerHtmlDialogComponent } from './inner-html-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { GoogleMapsModule } from '@angular/google-maps';




@NgModule({
  declarations: [
    InnerHtmlDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
    MatIconModule,
    GoogleMapsModule

],
  exports: [
    InnerHtmlDialogComponent,
    GoogleMapsModule
  ]
})
export class InnerHtmlDialogModule { }
